__turbopack_context__.v({
  "asymmetricMobile": "CampaignCardBlok-module__82QCmG__asymmetricMobile",
  "background": "CampaignCardBlok-module__82QCmG__background",
  "description": "CampaignCardBlok-module__82QCmG__description",
  "link": "CampaignCardBlok-module__82QCmG__link",
  "media": "CampaignCardBlok-module__82QCmG__media",
  "mediaWrap": "CampaignCardBlok-module__82QCmG__mediaWrap",
  "reverse": "CampaignCardBlok-module__82QCmG__reverse",
  "root": "CampaignCardBlok-module__82QCmG__root",
  "text": "CampaignCardBlok-module__82QCmG__text",
  "textWrap": "CampaignCardBlok-module__82QCmG__textWrap",
  "title": "CampaignCardBlok-module__82QCmG__title",
});
